:host {
  display: flex;
  grid-column-start: 1;
  grid-column-end: -1;
}
.loading:not([hidden]) {
  display: contents;
}
